import { EventType } from '@/analytics/types';
import type { TextColProps } from '@/app/components/TwoColumnModule';
import TwoColumnModule from '@/app/components/TwoColumnModule';

export const motionProps = {
  initial: { filter: 'blur(5px)', opacity: 0 },
  style: { height: '100%' },
  transition: { delay: 0.5, duration: 0.5 },
  viewport: { once: true },
  whileInView: { filter: 'blur(0px)', opacity: 1 },
};

const SecuritySection = () => {
  const handleClick = async (): Promise<void> => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'go to security',
      cta: 'learn more',
      location: 'bottom of page',
      path: 'https://ouraring.com/security',
    });
  };
  const buttonProps: TextColProps['buttonProps'] = {
    label: 'learn_more',
    className: 'w-fit text-body-sm md:text-[16px]',
    variant: 'secondary-dark',
    href: '/security',
    onClick: () => handleClick(),
  };
  const textCol: TextColProps = {
    titleProps: {
      label: 'membership_two_col_title_health_data',
      className:
        'lg:text-6xl md:text-5xl text-2xl  text-sandstone-500 font-normal md:font-light pb-6 max-w-[480px]',
    },
    paragraphs: [
      {
        textProps: {
          label: 'membership_two_col_subtext_rest_assure',
          className: 'md:text-[16px] max-w-[480px] md:pb-0 pb-1.5',
          color: 'unset',
        },
      },
    ],
  };
  return (
    <div
      className="relative pt-20 pb-0 md:py-20"
      data-cy="membership-security-section"
    >
      <TwoColumnModule
        imageCol={{
          src: 'momAndDaughter',
          localizedAlt: 'membership_image_alt_mother_daughter',
          motionProps,
        }}
        smBreakTextPos="bottom"
        mdBreakTextPos="right"
        textCol={{ ...textCol, buttonProps }}
      />
    </div>
  );
};

export default SecuritySection;
